import axios from 'axios';
async function regSw () {
  if ('serviceWorker' in navigator) {
    const baseUrl = (process.env.REACT_APP_URL || window.location.origin).replace(/\/+$/, '');
    const url = `${baseUrl}/sw.js`;
    const reg = await navigator.serviceWorker.register(url, { scope: '/' });
    console.log ('service config is', {reg});
    return reg;
  }
  return null;
}
const serverURL = process.env.REACT_APP_API;
const applicationServerKey = 'BBvXfrCqaLPzK55HigNB1XHp3r6b8JqsLwlpduxTpoSqvI-jgKpEWxK_zdFtTIOhxdTjcgXsw-TqnPaNdwvNJsM';
async function getOrCreateSubscription() {
  try {
    const serviceWorkerReg = await regSw();
    if (!serviceWorkerReg || !serviceWorkerReg.pushManager) {
      console.warn('Push not supported in this environment');
      return null;
    }

    let subscription = await serviceWorkerReg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await serviceWorkerReg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
      });
    }

    return subscription;
  } catch (error) {
    console.error('Subscription init failed:', error);
    return null;
  }
}
async function subscribe(serviceWorkerReg,userName,total) {
    try {
      if (!serviceWorkerReg || !serviceWorkerReg.pushManager) {
        console.warn('Push not supported in this environment');
        return;
      }
      let subscription = await serviceWorkerReg.pushManager.getSubscription();
      console.log({ subscription });
      
      if (subscription === null) {
        subscription = await serviceWorkerReg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey,
        });
  

       const subscriptionData = {
        subscription,
        userName,
        total,
      };
        await axios.post(`${serverURL}/subscribe`, subscriptionData);
      }
      const subscriptionData = {
        subscription,
        userName,
        total,
      }
      await axios.post(`${serverURL}/subscribe`, subscriptionData);
    } catch (error) {
      console.error('Subscription failed:', error);
    }
  }
  
  export {regSw, subscribe, getOrCreateSubscription};
